import { gql } from "@apollo/client";

export const INSERT_REFERRAL_SCHEME = gql`
  mutation MyMutation($referral_scheme: courses_referral_scheme_insert_input!) {
    insert_courses_referral_scheme_one(object: $referral_scheme) {
      id
    }
  }
`;
